// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../config/styles';
import blueCloud from '../../../images/sign-in-cloud.png';
import blueCloudMobile from '../../../images/sign-in-mobile-cloud.png';

const styles = theme => ({
  mainContainer: {
    display: 'flex',
    minHeight: 'calc(100vh - 270px)',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    marginBottom: 20,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_LARGE,
    color: GlobalStyles.color.COLOR_PRIMARY,
    [theme.breakpoints.down(900)]: {
      marginBottom: 10,
      marginRight: 20,
    },
    [theme.breakpoints.down(400)]: {
      marginRight: 0,
    },
  },
  arrowBackContainer: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    color: GlobalStyles.color.COLOR_PRIMARY,
    left: -130,
    cursor: 'pointer',
    [theme.breakpoints.down(900)]: {
      left: -30,
    },
    [theme.breakpoints.down(400)]: {
      left: 0,
    },
  },
  backLink: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
  },
  subContainer: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    alignItems: 'center',
    zIndex: 10,
  },
  imageContainer: {
    display: 'flex',
    width: 800,
    height: 500,
    justifyContent: 'center',
    alignItems: 'center',

    backgroundImage: `url(${blueCloud})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    [theme.breakpoints.down(900)]: {
      width: 600,
      height: 400,
    },
    [theme.breakpoints.down(650)]: {
      height: 390,
      fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    },
    [theme.breakpoints.down(580)]: {
      backgroundImage: `url(${blueCloudMobile})`,
      minWidth: '100%',
      maxWidth: '100%',
      padding: '70px 0',
      height: '100%',
      backgroundSize: '100% 100%',
    },
  }
});

export default styles;
